<div fxLayout="row" fxLayoutAlign="end end">
	<button mat-icon-button (click)="close()">
		<mat-icon>close</mat-icon>
	</button>
</div>
<div *ngIf="transactionHistory?.length || tripHistory?.length">
	<div *ngIf="transactionHistory?.length">
		<h2 mat-dialog-title>Transaction History</h2>
		<mat-dialog-content>
			<app-changes-display [history]="transactionHistory"></app-changes-display>
		</mat-dialog-content>
	</div>
	<div *ngIf="tripHistory?.length">
		<h2 mat-dialog-title>Trip History</h2>
		<mat-dialog-content>
			<app-changes-display [history]="tripHistory"></app-changes-display>
		</mat-dialog-content>
	</div>
</div>
